interface Props {
  label: string;
  value: string;
}

const SingleDetail: React.FC<Props> = ({ label, value }) => (
  <div className="single-detail border-b border-secondary-grey py-1-0 text-body1 font-li flex">
    <div className="single-detail__label w-full max-w-[200px]">
      <p>{label}:</p>
    </div>
    <div className="single-detail_value">
      <p>{value}</p>
    </div>
  </div>
);

export default SingleDetail;
